export const xSmallSize = 24;
export const smallSize = 30;
export const mediumSize = 36;
export const largeSize = 42;
export const fontSizeXSmall = 12;
export const fontSizeSmall = 13;
export const fontSizeMedium = 14;
export const fontSizeLarge = 15;
export const iconSizeXSmall = 16;
export const iconSizeSmall = 18;
export const iconSizeMedium = 20;
export const iconSizeLarge = 24;
